export const PDP_TOP_SIMILAR_ITEMS_COUNT = 6;
export const PDP_TOP_SIMILAR_ITEMS_COUNT_VARIANT = 7;
